import { render, staticRenderFns } from "./setAccount.vue?vue&type=template&id=ffa4a896"
import script from "./setAccount.vue?vue&type=script&lang=js"
export * from "./setAccount.vue?vue&type=script&lang=js"
import style0 from "./setAccount.vue?vue&type=style&index=0&id=ffa4a896&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffa4a896')) {
      api.createRecord('ffa4a896', component.options)
    } else {
      api.reload('ffa4a896', component.options)
    }
    module.hot.accept("./setAccount.vue?vue&type=template&id=ffa4a896", function () {
      api.rerender('ffa4a896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimWorkOrder/setCollectAccountByQuick/setAccount.vue"
export default component.exports